export const getCountryOptions = (countries) => {
    return countries.map((item) => ({
        label: item.name,
        value: item.name,
    }));
};
